import React, {
  useEffect,
  useState,
} from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Descriptions,
  Input,
  List,
  Modal,
  Popconfirm,
  Select,
} from 'antd';
import i18n from '../../config/i18n';

const { Option } = Select;


const SignupList = ({
  signupList,
  isLoading,
  metadata: {
    title,
    specialty,
    medicalGroup,
  },
  actions: {
    getSignupList,
    approveSignup,
    declineSignup,
  },
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingSignup, setEditingSignup] = useState({});
  const [isInputDisabled, setIsInputDisabled] = useState(false);

  useEffect(() => {
    getSignupList();
  }, [getSignupList]);

  const onConfirmClick = async () => {
    setIsModalVisible(false);
    await approveSignup(editingSignup);
  };

  const onCancelClick = () => {
    setIsModalVisible(false);
  };

  const onApproveClick = (item) => {
    setIsModalVisible(true);
    setEditingSignup(item);
  };

  const getNameById = (data, id) => (
    ((data || []).find(datum => datum.id === id) || {}).name
  );

  const onInputChange = ({ target: { value } }) => {
    setEditingSignup({
      ...editingSignup,
      medicalGroup: value,
    });
  };

  const onSelect = (value) => {
    setIsInputDisabled(!!value);
    setEditingSignup({
      ...editingSignup,
      medicalGroupId: value,
    });
  };

  const generateSelectOption = (data) => {
    // Default option.
    const options = [
      <Option key="no-selected" value="">-- {i18n.t('select')} --</Option>,
    ];

    (data || []).forEach((obj) => {
      options.push(<Option key={obj.name} value={obj.id}>{obj.name}</Option>);
    });

    return options;
  };

  return (
    <div>
      <h2>
        {i18n.t('signupList')}
      </h2>
      <List
        bordered
        loading={isLoading}
        dataSource={signupList}
        renderItem={item => (
          <List.Item
            actions={[
              <Button
                type="primary"
                onClick={() => { onApproveClick(item); }}
              >
                {i18n.t('approve')}
              </Button>,
              <Popconfirm
                title={i18n.t('sureToDecline')}
                onConfirm={() => { declineSignup(item.id); }}
              >
                <Button
                  type="danger"
                >
                  {i18n.t('decline')}
                </Button>
              </Popconfirm>,
            ]}
          >
            <List.Item.Meta
              title={
                <div style={{ paddingBottom: 12 }}>
                  <span style={{ fontSize: 24 }}>
                    {item.firstName} {item.lastName}
                  </span>
                </div>
              }
              description={
                <Descriptions column={1}>
                  <Descriptions.Item label={i18n.t('email')}>
                    {item.email}
                  </Descriptions.Item>
                  <Descriptions.Item label={i18n.t('group')}>
                    {item.medicalGroup}
                  </Descriptions.Item>
                  <Descriptions.Item label={i18n.t('specialty')}>
                    {getNameById(specialty, item.specialtyId)}
                  </Descriptions.Item>
                  <Descriptions.Item label={i18n.t('title')}>
                    {getNameById(title, item.titleId)}
                  </Descriptions.Item>
                  <Descriptions.Item label={i18n.t('npi')}>
                    {item.npi}
                  </Descriptions.Item>
                </Descriptions>
              }
            />
          </List.Item>
        )}
      />
      <Modal
        title={i18n.t('confirmSignupTitle')}
        visible={isModalVisible}
        onOk={onConfirmClick}
        onCancel={onCancelClick}
        okText={i18n.t('confirm')}
        cancelText={i18n.t('cancel')}
        okButtonProps={{ disabled: !isInputDisabled && editingSignup.medicalGroup === '' }}
      >
        <Descriptions column={1}>
          <Descriptions.Item label={i18n.t('email')}>
            {editingSignup.email}
          </Descriptions.Item>
          <Descriptions.Item label={i18n.t('group')}>
            <Input
              value={editingSignup.medicalGroup}
              onChange={onInputChange}
              disabled={isInputDisabled}
            />
            <Select
              defaultValue=""
              onSelect={onSelect}
              key={editingSignup.email}
              style={{ width: '100%' }}
            >
              {generateSelectOption(medicalGroup)}
            </Select>
          </Descriptions.Item>
          <Descriptions.Item label={i18n.t('specialty')}>
            {getNameById(specialty, editingSignup.specialtyId)}
          </Descriptions.Item>
          <Descriptions.Item label={i18n.t('title')}>
            {getNameById(title, editingSignup.titleId)}
          </Descriptions.Item>
          <Descriptions.Item label={i18n.t('npi')}>
            {editingSignup.npi}
          </Descriptions.Item>
        </Descriptions>
      </Modal>
    </div>
  );
};

SignupList.propTypes = {
  signupList: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    medicalGroup: PropTypes.string.isRequired,
    specialtyId: PropTypes.number.isRequired,
    titleId: PropTypes.number,
    npi: PropTypes.string,
  })),
  isLoading: PropTypes.bool,
  metadata: PropTypes.shape({
    medicalGroup: PropTypes.arrayOf(PropTypes.object).isRequired,
    specialty: PropTypes.arrayOf(PropTypes.object).isRequired,
    title: PropTypes.arrayOf(PropTypes.object).isRequired,
  }),
  actions: PropTypes.shape({
    getSignupList: PropTypes.func.isRequired,
    approveSignup: PropTypes.func.isRequired,
    declineSignup: PropTypes.func.isRequired,
  }).isRequired,
};

SignupList.defaultProps = {
  signupList: [],
  metadata: {
    medicalGroup: [],
    specialty: [],
    title: [],
  },
  isLoading: false,
};

export default SignupList;



// WEBPACK FOOTER //
// ./src/components/team/SignupList.js